import React, { useState, useEffect } from 'react';
import cassImage from './cass.png'; 
import SchoolIcon from '@mui/icons-material/School';
import ClassesModel from "./ClassesModel";
import CircularProgress from "@mui/material/CircularProgress";


const Classes = () => {
  const [classes, setClasses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
const [flipped, setFlipped] = useState(false);
const [active, setActive] = useState(false); // 👉 CLICK lighting साठी
const [openModel, setOpenModel] = useState(false);

  useEffect(() => {
    const fetchClasses = async () => {
      setLoading(true);
      setError(false);
      try {
        const response = await fetch('https://wsmsv1.aidigitalsec.com/api/TeacherDashboard/Dashboard_ClassCard', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: sessionStorage.getItem('token'),
          },
        });

        if (!response.ok) {
          throw new Error('Failed to fetch');
        }

        const data = await response.json();

        if (!data.list || data.list.length === 0 || (data.data === null && data.msg === "Record Not Found")) {
          setClasses([]);
          return;
        }

        const classesMap = {};
        data.list.forEach(item => {
          if (!classesMap[item.className]) {
            classesMap[item.className] = {
              className: item.className,
              sections: []
            };
          }
          
          classesMap[item.className].sections.push({
            sectionName: item.sectionName,
            studentCount: item.studentCount || 0
          });
        });

        setClasses(Object.values(classesMap));
      } catch (error) {
        console.error('Error fetching classes:', error);
        setError(true);
        setClasses([]);
      } finally {
        setLoading(false);
      }
    };

    fetchClasses();
  }, []);

const styles = {
  cardFlip: {
    width: 270,
    height: 185,
    perspective: "1800px",
    borderRadius: 22,
  },

  inner: {
    position: "relative",
    width: "100%",
    height: "100%",
    transition: "transform 0.75s cubic-bezier(0.4,0,0.2,1)",
    transformStyle: "preserve-3d",
    transform: flipped ? "rotateY(180deg)" : "rotateY(0deg)",
  },

  /* ================= FRONT ================= */
  front: {
    position: "absolute",
    inset: 0,
    backfaceVisibility: "hidden",
    borderRadius: 22,
 background: `
  linear-gradient(135deg, #080F1F 0%, #102A43 55%, #1B4965 100%)
`,


    boxShadow: "0 25px 60px #063552",

    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    cursor: "pointer",
    color: "#ffffff",
  },

frontGlow: {
  boxShadow: `
    0 0 0 1px rgba(255,255,255,0.3),
    0 0 30px rgba(245,158,11,0.9),
    0 0 80px rgba(251,191,36,0.7)
  `,
  transform: "translateY(-6px) scale(1.03)",
},



 frontTitle: {
  fontSize: 22,
  fontWeight: 900,
  letterSpacing: "1px",
  textShadow: "0 2px 8px rgba(0,0,0,0.35)",
},


  frontSub: {
    fontSize: 12,
    opacity: 0.85,
    marginTop: 6,
  },

  /* ================= BACK ================= */
  back: {
    position: "absolute",
    inset: 0,
    backfaceVisibility: "hidden",
    transform: "rotateY(180deg)",
    borderRadius: 22,
    background:
      "linear-gradient(145deg,#ffffff,#f8fafc)",
    boxShadow:
      "0 25px 60px rgba(0,0,0,0.18)",
    padding: 14,
    overflowY: "auto",
  },

  backHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 8,
    marginBottom: 8,
    color: "#063552",
    fontWeight: 800,
    fontSize: 14,
  },

  classInfo: {
    background: "linear-gradient(135deg,#FFF7ED,#FFEDD5)",

    border: "1px solid #E5E7EB",
    borderRadius: 14,
    padding: "8px 10px",
    marginBottom: 8,
  },

  classTitle: {
    fontSize: 13,
    fontWeight: 800,
    color: "#1E3A8A",
    marginBottom: 6,
  },

  sectionRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    fontSize: 12,
    color: "#334155",
    margin: "3px 0",
  },

  badge: {
    background: "linear-gradient(135deg,#F59E0B,#D97706)",

    color: "#fff",
    borderRadius: 999,
    padding: "2px 9px",
    fontSize: 11,
    fontWeight: 800,
    minWidth: 28,
    textAlign: "center",
  },

  emptyText: {
    fontSize: 13,
    color: "#64748B",
    textAlign: "center",
    marginTop: 18,
  },
};



useEffect(() => {
  if (active) {
    const timer = setTimeout(() => setActive(false), 1200);
    return () => clearTimeout(timer);
  }
}, [active]);



  

 return (
  <>
    <div style={styles.cardFlip}>
      <div
        style={styles.inner}
        tabIndex={-1}
        onMouseDown={(e) => e.preventDefault()}
        onClick={() => setOpenModel(true)}
      >
        {/* FRONT */}
       {/* FRONT */}
<div
  style={{
    ...styles.front,
    ...(active ? styles.frontGlow : {}),
  }}
>
  {loading && (
    <>
      <CircularProgress sx={{ color: "#fff", mb: 1.5 }} />
      <p style={styles.frontSub}>Loading Classes...</p>
    </>
  )}

  {!loading && !error && (
    <>
      <img src={cassImage} alt="cass" style={{ width: 46, marginBottom: 10 }} />
      <h2 style={styles.frontTitle}>Classes</h2>
      <p style={styles.frontSub}>Total classes & sections</p>
    </>
  )}

  {error && !loading && (
    <p style={{ color: "#fecaca", fontWeight: 800 }}>
      Failed to load
    </p>
  )}
</div>


        {/* BACK */}
        <div style={styles.back}>
          <div style={styles.backHeader}>
            <SchoolIcon sx={{ fontSize: 28 }} />
            Class Details
          </div>

          {classes.length === 0 ? (
            <p style={styles.emptyText}>No classes found</p>
          ) : (
            classes.map((cls) => (
              <div key={cls.className} style={styles.classInfo}>
                <h3 style={styles.classTitle}>{cls.className}</h3>
                {cls.sections.map((sec) => (
                  <div key={sec.sectionName} style={styles.sectionRow}>
                    <span>{sec.sectionName}</span>
                    <span style={styles.badge}>{sec.studentCount}</span>
                  </div>
                ))}
              </div>
            ))
          )}
        </div>
      </div>
    </div>

    {/* 🔥 MODAL */}
    {openModel && (
      <ClassesModel
        classes={classes}
        onClose={() => setOpenModel(false)}
      />
    )}
  </>
);


};

export default Classes;